import { DefaultTheme } from 'styled-components';
import { darkTheme, lightTheme } from './theme';

export const consoleLightTheme: DefaultTheme = {
  ...lightTheme,
  color: {
    primary_50: '#F3F4F6', primary_100: '#FFFFFF', primary_200: '#FFFFFF',
    primary_300: '#E5E7EB', primary_400: '#838B97',
    point_y_100: '#694D72', point_y_200: '#563D60', point_y_300: '#667085',
    point_n_100: '#B42318', point_n_200: '#912018', point_n_300: '#B42318',
    text_color_100: '#202124', text_color_200: '#515965', text_color_300: '#667085', text_color_400: '#98A2B3',
  },
};
export const consoleDarkTheme: DefaultTheme = {
  ...darkTheme,
  color: {
    primary_50: '#272A30', primary_100: '#1E2024', primary_200: '#1E2024',
    primary_300: '#3A3F47', primary_400: '#69717D',
    point_y_100: '#D0B1D4', point_y_200: '#E0CAE2', point_y_300: '#A0A8B4',
    point_n_100: '#FF9D97', point_n_200: '#FFB3AE', point_n_300: '#FF9D97',
    text_color_100: '#F1F3F5', text_color_200: '#C2C7D0', text_color_300: '#A0A8B4', text_color_400: '#707987',
  },
};
export const statusColors = {
  light: { success: '#167347', info: '#2855D9', warning: '#925300', danger: '#B42318', neutral: '#667085' },
  dark: { success: '#70DB9A', info: '#8BA8FF', warning: '#F6C768', danger: '#FF9D97', neutral: '#A0A8B4' },
};
export type StatusTone = keyof typeof statusColors.light;
export const callStatusTone = (status: string): StatusTone => ({
  COMPLETED: 'success', MISSED: 'danger', RINGING: 'info', INUSE: 'warning', BUSY: 'warning',
} as Record<string, StatusTone>)[status] || 'neutral';
export const onAccent = (theme: DefaultTheme) => theme.name === 'dark' ? '#101828' : '#FFFFFF';
